import React from 'react';

const BackToTop = ({ onClick, variant = "v1", className }) => {
    if (variant === "persona") {
        return (
            <button
                type="button"
                onClick={onClick}
                className={`flex items-center justify-center bg-black text-[#FFF200] border-2 md:border-[3px] border-white font-bebas text-xl md:text-2xl shadow-[4px_4px_0_#000] hover:-translate-y-1 transition-transform focus:outline-none focus-visible:ring-4 focus-visible:ring-white z-50 h-12 w-auto px-4 md:px-0 md:w-12 ${className || "fixed bottom-8 right-6 md:bottom-8 md:right-20"}`}
                aria-label="Scroll back to top"
            >
                <span className="hidden md:inline">▲</span>
                <span className="md:hidden">▲ BACK TO TOP</span>
            </button>
        );
    }

    return (
        <button
            type="button"
            onClick={onClick}
            className={`fixed bottom-10 right-10 z-50 p-3 bg-cherry-blossom/10 text-cherry-blossom rounded-full border border-cherry-blossom/30 shadow-lg hover:bg-cherry-blossom hover:text-dark-blue transition-all focus:outline-none focus-visible:ring-2 focus-visible:ring-cherry-blossom group ${className || ''}`}
            aria-label="Scroll back to top"
        >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="w-6 h-6 group-hover:-translate-y-1 transition-transform">
                <path fillRule="evenodd" d="M10 17a.75.75 0 01-.75-.75V5.612L5.29 9.77a.75.75 0 01-1.08-1.04l5.25-5.5a.75.75 0 011.08 0l5.25 5.5a.75.75 0 11-1.08 1.04l-3.96-4.158V16.25A.75.75 0 0110 17z" clipRule="evenodd" />
            </svg>
        </button>
    );
};

export default BackToTop;